export { pageName as foodPlanner } from './food-planner';
export const foodTable = 'food-nutrition';
export { pageName as offCalc } from './off-calc';
export { pageName as defCalc } from './def-calc';
export const mining = 'mining';
export const comfort = 'comfort';
export const skills = 'skills';
